import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';

import { Input, Button } from 'components';

import './GenerateOTPPopup.scss';

interface Props {
    intl: { formatMessage },
    showOtpPopup: boolean,
    onClose: ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void) | undefined,
    onGenerateOtp,
}

interface State {
    phoneNumber: string,
    otp: string,
}

class GenerateOTPPopup extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      otp: '',
    };
  }

    handleChange = (e) => {
      this.setState({ phoneNumber: e.target.value });
    }

    handleClose = (e) => {
      const { onClose } = this.props;
      this.setState({ otp: '', phoneNumber: '' });
      onClose(e);
    }

    generateOtp = async (e) => {
      e.preventDefault();
      const { onGenerateOtp } = this.props;
      const otp = await onGenerateOtp(this.state.phoneNumber);
      this.setState({ otp });
    }

    render() {
      const { showOtpPopup } = this.props;
      const { phoneNumber, otp } = this.state;
      const { intl: { formatMessage } } = this.props;

      return showOtpPopup
        ? (
          <div className="layout modal-overlay">
            <section className="modal update-status">
                <span className="modal__close" onClick={this.handleClose} />
                <header className="modal__header">
                <ul>
                <li>{formatMessage({ id: 'navbar.otp' })}</li>
              </ul>
              </header>
                <div className="modal__content generate-otp__content">
                <form onSubmit={this.generateOtp}>
                <Input
                    label={formatMessage({ id: 'dashboard.generateOtp.phoneNumber' })}
                    type="text"
                    placeholder="e.g. +6582009924"
                    name="phoneNumber"
                    id="phoneNumber"
                    value={phoneNumber}
                    onInputChange={this.handleChange}
                  />

                <Button
                    type="submit"
                    value={formatMessage({ id: 'dashboard.generateOtp.generate' })}
                    isDisabled={!phoneNumber}
                    isBig
                  />
              </form>

                {
                otp ? (
                  <>
  <table>
                  <tr>
                      <td>{otp}</td>
                    </tr>
                </table>
  <small>{formatMessage({ id: 'dashboard.generateOtp.expireTooltip' })}</small>
</>
                ) : null
}
              </div>
              </section>
          </div>
        ) : <></>;
    }
}

export default injectIntl(GenerateOTPPopup);
